import { useSyncExternalStore } from "react";

const KEY = "sp_lang";
const subs = new Set();
const norm = (v) => (v === "en" ? "en" : "fr");
const urlLang = new URLSearchParams(window.location.search).get("lang");
let cur = norm(urlLang || localStorage.getItem(KEY));
if (urlLang) localStorage.setItem(KEY, cur);

export const setLang = (l) => { cur = norm(l); localStorage.setItem(KEY, cur); document.documentElement.lang = cur; subs.forEach((f) => f()); };
export const useLang = () => useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb); }, () => cur);
